import { render, staticRenderFns } from "./GoodsSimpleMessage.vue?vue&type=template&id=61d61ee0&scoped=true"
import script from "./GoodsSimpleMessage.vue?vue&type=script&lang=js"
export * from "./GoodsSimpleMessage.vue?vue&type=script&lang=js"
import style0 from "./GoodsSimpleMessage.vue?vue&type=style&index=0&id=61d61ee0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d61ee0",
  null
  
)

export default component.exports